/* ============================================================
   THE UNLUCKY CASS — Carrossel horizontal reutilizável

   Extraído da seção "Drop Vol. 1" para ser compartilhado.
   Vanilla, sem dependências. O conteúdo já vem no HTML: este
   script só adiciona navegação por setas e pontos.

   Marcação esperada:
     <div data-uc-carousel>
       <div data-uc-carousel-track>
         <div data-uc-carousel-slide>…</div>
       </div>
       <div data-uc-carousel-controls>          (opcional)
         <button data-uc-carousel-prev>
         <div data-uc-carousel-dots></div>
         <button data-uc-carousel-next>
       </div>
     </div>

   Sem JS o track continua rolando por toque/trackpad normalmente.
   ============================================================ */

(function () {
  'use strict';

  function setupCarousel(root) {
    var track = root.querySelector('[data-uc-carousel-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-uc-carousel-slide]'));
    if (!slides.length) return;

    var prevBtn = root.querySelector('[data-uc-carousel-prev]');
    var nextBtn = root.querySelector('[data-uc-carousel-next]');
    var dotsEl = root.querySelector('[data-uc-carousel-dots]');

    function slideWidth() {
      return slides[0].getBoundingClientRect().width;
    }

    function gap() {
      var g = parseInt(window.getComputedStyle(track).columnGap, 10);
      return isNaN(g) ? 0 : g;
    }

    function stride() {
      return slideWidth() + gap();
    }

    function perView() {
      var w = slideWidth();
      if (!w) return 1;
      return Math.max(1, Math.round(track.clientWidth / w));
    }

    function totalPages() {
      return Math.max(1, Math.ceil(slides.length / perView()));
    }

    function currentPage() {
      var s = stride();
      if (!s) return 0;
      return Math.min(Math.round(track.scrollLeft / (s * perView())), totalPages() - 1);
    }

    function goToPage(page) {
      var pages = totalPages();
      page = Math.max(0, Math.min(page, pages - 1));
      var target = Math.min(page * perView(), slides.length - 1);
      track.scrollTo({ left: target * stride(), behavior: 'smooth' });
    }

    function onDotClick(event) {
      goToPage(Number(event.currentTarget.dataset.page));
    }

    function buildDots() {
      if (!dotsEl) return;
      dotsEl.innerHTML = '';
      var pages = totalPages();

      // Uma página só: não há o que navegar.
      if (pages < 2) {
        root.classList.add('uc-carousel--static');
        syncState();
        return;
      }
      root.classList.remove('uc-carousel--static');

      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'uc-carousel__dot';
        dot.dataset.page = i;
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Página ' + (i + 1) + ' de ' + pages);
        dot.addEventListener('click', onDotClick);
        dotsEl.appendChild(dot);
      }
      syncState();
    }

    function syncState() {
      var page = currentPage();
      var pages = totalPages();

      if (dotsEl) {
        Array.prototype.forEach.call(dotsEl.children, function (dot, i) {
          var active = i === page;
          dot.classList.toggle('uc-carousel__dot--active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      if (prevBtn) prevBtn.disabled = page === 0;
      if (nextBtn) nextBtn.disabled = page >= pages - 1;
    }

    if (prevBtn && !prevBtn.dataset.ucBound) {
      prevBtn.dataset.ucBound = '1';
      prevBtn.addEventListener('click', function () {
        goToPage(currentPage() - 1);
      });
    }

    if (nextBtn && !nextBtn.dataset.ucBound) {
      nextBtn.dataset.ucBound = '1';
      nextBtn.addEventListener('click', function () {
        goToPage(currentPage() + 1);
      });
    }

    if (!track.dataset.ucBound) {
      track.dataset.ucBound = '1';
      track.addEventListener('scroll', syncState, { passive: true });
    }

    buildDots();

    // Recalcula ao redimensionar: a quantidade de cards por página muda.
    if (!root.dataset.ucResizeBound) {
      root.dataset.ucResizeBound = '1';
      var resizeTimer;
      window.addEventListener(
        'resize',
        function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(buildDots, 150);
        },
        { passive: true }
      );
    }
  }

  function initAll() {
    document.querySelectorAll('[data-uc-carousel]').forEach(setupCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // bfcache: voltar pelo histórico não dispara DOMContentLoaded.
  window.addEventListener('pageshow', initAll);

  // Editor de temas: a seção é reinjetada no DOM ao editar.
  document.addEventListener('shopify:section:load', initAll);

  window.ucCarouselInit = initAll;
})();
